import React, { useRef, useState } from 'react';
import { capitalCase } from 'change-case';
import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Popover,
  SvgIcon,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { Settings as SettingsIcon } from 'react-feather';
import { useSettings } from 'src/context/SettingsContext';
import { THEMES } from 'src/constants';
import LanguageSelector from './LanguageSelector';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
import { Theme } from '@mui/material/styles';
import useCustomStyles from 'src/hooks/useCustomStyles';

const styles = (theme: Theme) => ({
  popover: {
    width: 320,
    padding: theme.spacing(2),
  },
});

const Settings = () => {
  const ref = useRef(null);
  const { settings, saveSettings } = useSettings();
  const classes = useCustomStyles(styles);
  const [isOpen, setOpen] = useState(false);
  const [values, setValues] = useState({
    direction: settings.direction,
    locale: settings.locale,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme,
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (field: string, value: any) => {
    setValues({
      ...values,
      [field]: value,
    });
  };

  const handleSave = () => {
    saveSettings(values);
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Settings">
        {/*<Badge
          color="secondary"
          variant="dot"
          classes={{ badge: clsx(classes.badge) }}
         >*/}
        <IconButton color="inherit" onClick={handleOpen} ref={ref} size="large">
          <SvgIcon fontSize="small">
            <SettingsIcon />
          </SvgIcon>
        </IconButton>
        {/*</Badge>*/}
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        classes={{ paper: classes.popover }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}>
        <Typography variant="h4" color="textPrimary">
          Settings
        </Typography>
        <Box mt={2} px={1}>
          <FormControlLabel
            control={
              <Switch
                checked={values.responsiveFontSizes}
                edge="start"
                name="direction"
                onChange={(event) =>
                  handleChange('responsiveFontSizes', event.target.checked)
                }
              />
            }
            label="Responsive font sizes"
          />
        </Box>
        <Box mt={2}>
          
          <Box mt={2}>
            <LanguageSelector
              onchange={(value) => handleChange('locale', value)}
              value={values.locale}
            />
          </Box>
        </Box>
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSave}>
            Save Settings
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default Settings;
